(() => {
  const initSoluciones = (root = document) => {
    root.querySelectorAll('[data-soluciones-section][data-mobile-carousel="true"]').forEach((section) => {
      if (section.dataset.solucionesReady === 'true') return;
      section.dataset.solucionesReady = 'true';

      const track = section.querySelector('[data-soluciones-track]');
      const prev = section.querySelector('[data-soluciones-prev]');
      const next = section.querySelector('[data-soluciones-next]');
      if (!track || !prev || !next) return;

      const getStep = () => {
        const card = track.querySelector('.soluciones__card');
        if (!card) return track.clientWidth * 0.86;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || 16) || 16;
        return card.getBoundingClientRect().width + gap;
      };

      const scrollToDirection = (direction) => {
        const step = getStep();
        const maxScroll = track.scrollWidth - track.clientWidth - 2;

        if (direction > 0 && track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        if (direction < 0 && track.scrollLeft <= 2) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
          return;
        }

        track.scrollBy({ left: step * direction, behavior: 'smooth' });
      };

      prev.addEventListener('click', () => scrollToDirection(-1));
      next.addEventListener('click', () => scrollToDirection(1));
    });
  };

  document.addEventListener('DOMContentLoaded', () => initSoluciones());
  document.addEventListener('shopify:section:load', (event) => initSoluciones(event.target));
})();
